import React, { useState, useEffect, useRef } from "react";
import { useSelector, useDispatch } from "react-redux";
import {
  Form,
  Input,
  Button,
  Select,
  DatePicker,
  Switch,
  Modal,
  Upload,
  Tooltip,
  Dropdown,
  Drawer,
  InputNumber,
  Checkbox,
  Badge,
  message,
} from "antd";
import {
  PlusOutlined,
  DeleteOutlined,
  CopyOutlined,
  SettingOutlined,
  SwapOutlined,
  InfoCircleOutlined,
  BankOutlined,
  CalendarOutlined,
  FileExcelOutlined,
  FileTextOutlined,
  UploadOutlined,
  SearchOutlined,
  FilterOutlined,
  StarOutlined,
  StarFilled,
  CloudUploadOutlined,
  DownOutlined,
  ReloadOutlined,
  SaveOutlined,
  SendOutlined,
  CreditCardOutlined,
} from "@ant-design/icons";
import { CisUI, AllCurrency } from "../../../../util/CISUI";
import Config from "../../../../util/config";
import axios from "../../../../util/Api";
import { setCurrency as setReduxCurrency } from "../../../../appRedux/actions/Common";
import SelectData from "../../../../util/selectdata";
import CreateCustomerModal from "./components/CreateCustomerModal";
import CreateVendorModal from "./components/CreateVendorModal";
import { SystemAssistantSidebar, SystemAssistantDrawerContent } from "./components/SystemAssistant";
import { Link } from "react-router-dom";

const { Option } = Select;
const { TextArea } = Input;

const NewMultipleVoucher = (props) => {
  const [form] = Form.useForm();
  const formRef = useRef(null);
  const dispatch = useDispatch();
  const currentCurrencySymbol = useSelector(({ common }) => common.currency);

  const symbolToCode = { "₵": "GHC", "$": "USD", "£": "GBP", "€": "EUR", "C$": "CAD" };
  const codeToSymbol = { "GHC": "₵", "USD": "$", "GBP": "£", "EUR": "€", "CAD": "C$" };
  const defaultCurrencyCode = symbolToCode[currentCurrencySymbol] || "GHC";

  const [voucherType, setVoucherType] = useState("Payment");
  const [voucherNo, setVoucherNo] = useState("");
  const [paymentMethod, setPaymentMethod] = useState(2);
  const [isCash, setIsCash] = useState(false);
  const [bankAccountBalance, setBankAccountBalance] = useState(0);
  const [currency, setCurrency] = useState(defaultCurrencyCode);
  const [conversionRate, setConversionRate] = useState(0);
  const [checkStatus, setCheckStatus] = useState(false);
  const [applyAllBeneficiary, setApplyAllBeneficiary] = useState(false);
  const [isCIT, setIsCIT] = useState(false);
  const [loading, setLoading] = useState(false);

  const [bankaccounts, setBankAccounts] = useState([]);
  const [cashaccount, setCashAccount] = useState([]);
  const [filteredBankAccount, setFilteredBankAccount] = useState([]);
  const [accounts, setAccount] = useState([]);
  const [vendor, setVendor] = useState([]);
  const [customer, setCustomer] = useState([]);
  const [employee, setEmployee] = useState([]);
  const [mainAccount, setMainAccount] = useState([]);
  const [childAccount, setChildAccount] = useState([]);
  const [beneficiaryData, setBeneficiaryData] = useState({
    department: [],
    users: [],
    ministry: [],
    pentsos: [],
    area: [],
    district: [],
    local: [],
    subsector: [],
    committee: [],
    individuals: [],
  });

  const [rows, setRows] = useState([]);
  const [totalAmount, setTotalAmount] = useState(0);
  const [templatesVisible, setTemplatesVisible] = useState(false);
  const [saveTemplateVisible, setSaveTemplateVisible] = useState(false);
  const [loadTemplateVisible, setLoadTemplateVisible] = useState(false);
  const [selectedTemplate, setSelectedTemplate] = useState(null);
  const [templateSearch, setTemplateSearch] = useState("");
  const [attachments, setAttachments] = useState([]);
  const [showAssistant, setShowAssistant] = useState(true);
  const [showTip, setShowTip] = useState(true);

  const [customerModalVisible, setCustomerModalVisible] = useState(false);
  const [vendorModalVisible, setVendorModalVisible] = useState(false);
  const [addModalRowIdx, setAddModalRowIdx] = useState(null);

  const [isWideScreen, setIsWideScreen] = useState(window.innerWidth > 1440);
  const [drawerVisible, setDrawerVisible] = useState(false);

  useEffect(() => {
    const mq = window.matchMedia("(min-width: 1441px)");
    const handler = (e) => setIsWideScreen(e.matches);
    mq.addEventListener("change", handler);
    setIsWideScreen(mq.matches);
    return () => mq.removeEventListener("change", handler);
  }, []);

  const BankName = SelectData("banknames");
  const Benificiary = SelectData("accountbenificary");
  const PaymentMethod = SelectData("paymentmethod");

  const [saveTemplateForm] = Form.useForm();

  useEffect(() => {
    const code = symbolToCode[currentCurrencySymbol] || "GHC";
    setCurrency(code);
    form.setFieldsValue({ currency: code });
  }, [currentCurrencySymbol]);

  useEffect(() => {
    getVoucherNo();
    const comID = CisUI().getUserInfo("com_id");
    if (comID > 0) {
      loadBillEntryData(comID);
    }
  }, []);

  const getVoucherNo = (com_id = 0) => {
    let endpoint = "entries/getvoucherno";
    if (com_id > 0) endpoint += "?com_id=" + com_id;
    axios
      .get(Config.apiserver + endpoint)
      .then((res) => {
        if (res.data.status === 1) {
          setVoucherNo(res.data.data);
          form.setFieldsValue({ reference_no: res.data.data });
        }
      })
      .catch((err) => console.log(err));
  };

  const loadBillEntryData = (com_id) => {
    axios
      .get("billentrydata?com_id=" + com_id)
      .then((res) => {
        if (res.data.status === 1) {
          setVendor(res.data.vendor || []);
          setAccount(res.data.account || []);
          setBankAccounts(res.data.bank || []);
          setAllBankAccounts(res.data.bank || []);
          setEmployee(res.data.employee || []);
          setCustomer(res.data.customer || []);
          setCashAccount(res.data.cashaccount || []);
          setMainAccount(res.data.main_account || []);
          setChildAccount(res.data.child_account || []);
          setBeneficiaryData({
            department: res.data.department || [],
            users: res.data.users || [],
            ministry: res.data.ministry || [],
            pentsos: res.data.pentsos || [],
            area: res.data.area || [],
            district: res.data.district || [],
            local: res.data.local || [],
            subsector: res.data.subsector || [],
            committee: res.data.committee || [],
            individuals: res.data.individuals || [],
          });
          handleAddRow();
        }
      })
      .catch((err) => console.log(err));
  };

  const [allBankAccounts, setAllBankAccounts] = useState([]);

  const getBalance = (bank_account_id) => {
    axios
      .get(Config.apiserver + "getbalancebybankaccount/" + bank_account_id)
      .then((res) => {
        if (res.data.status === 1) {
          setBankAccountBalance(res.data.data.total_balance);
        }
      })
      .catch((err) => console.log(err));
  };

  const handleAddRow = () => {
    setRows((prev) => [
      ...prev,
      {
        account_id: null,
        sub_account_id: null,
        beneficiary_source: null,
        beneficiary_id: null,
        description: "",
        amount: 0,
        amount_in_ghc: 0,
        beneficiary: [],
        subaccounts: [],
      },
    ]);
  };

  const handleRemoveRow = (idx) => {
    if (rows.length <= 1) {
      message.warning("Cannot delete the last row.");
      return;
    }
    const filtered = rows.filter((_, i) => i !== idx);
    setRows(filtered);
    recalcTotal(filtered);
  };

  const handleDuplicateRow = (idx) => {
    const copy = { ...rows[idx], beneficiary_id: null };
    const newRows = [...rows];
    newRows.splice(idx + 1, 0, copy);
    setRows(newRows);
    recalcTotal(newRows);
  };

  const recalcTotal = (rowsData) => {
    const total = rowsData.reduce((sum, r) => sum + (parseFloat(r.amount) || 0), 0);
    setTotalAmount(total);
  };

  const handleRowChange = (idx, field, value) => {
    const newRows = [...rows];
    newRows[idx] = { ...newRows[idx], [field]: value };

    if (field === "account_id") {
      const sub = childAccount[parseInt(value)] || [];
      newRows[idx].subaccounts = sub;
      newRows[idx].sub_account_id = null;
    }

    if (field === "beneficiary_source") {
      let BF = [];
      if (value === 2) BF = customer;
      else if (value === 3) BF = vendor;
      else if (value === 4) BF = employee;
      else if (value === 5) BF = accounts;
      else if (value === 6) BF = beneficiaryData.department;
      else if (value === 7) BF = beneficiaryData.area;
      else if (value === 8) BF = employee;
      else if (value === 9) BF = beneficiaryData.users;
      else if (value === 10) BF = beneficiaryData.ministry;
      else if (value === 11) BF = beneficiaryData.pentsos;
      else if (value === 12) BF = beneficiaryData.district;
      else if (value === 13) BF = beneficiaryData.local;
      else if (value === 14) BF = beneficiaryData.committee;
      else if (value === 15) BF = beneficiaryData.subsector;
      else if (value === 17) BF = beneficiaryData.individuals;
      newRows[idx].beneficiary = BF;
      newRows[idx].beneficiary_id = null;
    }

    if (field === "amount" || field === "amount_in_ghc") {
      newRows[idx].amount_in_ghc =
        currency !== "GHC" ? Number(((conversionRate || 0) * Number(value)).toFixed(2)) : Number(value);
    }

    setRows(newRows);
    recalcTotal(newRows);
  };

  const handleBankChange = (value) => {
    const bank = BankName.filter((item) => item.bank_id === value);
    if (bank.length > 0) {
      const bk = bank[0];
      const filtered = bankaccounts.filter((item) => item.bank_id === bk.bank_id);
      setFilteredBankAccount(filtered);
    } else {
      setFilteredBankAccount([]);
    }
  };

  const handleBankAccountChange = (value) => {
    getBalance(value);
    if (!isCash) {
      const acct = bankaccounts.find((item) => item.id === value);
      if (acct) {
        const ref = acct.last_issued_check > 0 ? parseInt(acct.last_issued_check) + 1 : acct.starting_check_no;
        form.setFieldsValue({ check_no: ref });
      }
    }
  };

  const handlePaymentMethodChange = (value) => {
    setIsCash(value === 1);
    form.setFieldsValue({ bank_account_id: null });
  };

  const handleCurrencyChange = (value) => {
    setCurrency(value);
    dispatch(setReduxCurrency(codeToSymbol[value] || "₵"));
    if (value !== "GHC") {
      const newRows = rows.map((r) => ({
        ...r,
        amount_in_ghc: Number(((conversionRate || 0) * Number(r.amount)).toFixed(2)),
      }));
      setRows(newRows);
      recalcTotal(newRows);
    }
  };

  const handleConversionRateChange = (value) => {
    setConversionRate(value);
    const newRows = rows.map((r) => ({
      ...r,
      amount_in_ghc: Number((value * Number(r.amount)).toFixed(2)),
    }));
    setRows(newRows);
    recalcTotal(newRows);
  };

  const handleApplyAllBeneficiary = (checked) => {
    setApplyAllBeneficiary(checked);
    if (checked && rows.length > 1) {
      const first = rows[0];
      if (first.beneficiary_source && first.beneficiary_id) {
        const newRows = rows.map((r, i) =>
          i === 0
            ? r
            : {
                ...r,
                beneficiary_source: first.beneficiary_source,
                beneficiary_id: first.beneficiary_id,
                beneficiary: first.beneficiary,
              },
        );
        setRows(newRows);
      }
    }
  };

  const onFinish = (values) => {
    const hasInvalid = rows.some((r) => !r.account_id || !r.beneficiary_source || !r.beneficiary_id || !r.amount);
    if (hasInvalid) {
      message.warning("Account, Beneficiary Source and Beneficiary are required.");
      return;
    }

    let newRows = [];
    rows.map((items) => {
      newRows.push({
        id: items.id,
        account_id: items.account_id,
        sub_account_id: items.sub_account_id,
        description: items.description,
        checkno: items.checkno,
        beneficiary_source: items.beneficiary_source,
        beneficiary_id: items.beneficiary_id,
        payment_method: items.payment_method,
        bank_account_id: items.bank_account_id,
        amount: currency !== "GHC" ? items.amount_in_ghc : items.amount,
        dollar_amount: currency !== "GHC" ? items.amount : 0.0,
        conversion_rate: conversionRate,
        files: items.files,
        file_location: items.file_location,
      });
    });

    values["items"] = newRows;
    values["checque_status"] = checkStatus ? 1 : 0;
    values["is_cit"] = isCIT ? 1 : 0;

    setLoading(true);
    axios
      .post(Config.apiserver + "entries/manyvoucher", values)
      .then((res) => {
        setLoading(false);
        if (res.data.status === 1) {
          message.success(res.data.msg);
        } else {
          message.warning(res.data.msg);
        }
      })
      .catch(() => setLoading(false));
  };

  const handleCustomerCreated = (newCustomer) => {
    if (addModalRowIdx === null) return;
    const newRows = [...rows];
    const row = newRows[addModalRowIdx];
    const updatedBeneficiary = [
      ...(row.beneficiary || []),
      { id: newCustomer.id, name: newCustomer.full_name || newCustomer.name },
    ];
    newRows[addModalRowIdx] = {
      ...row,
      beneficiary: updatedBeneficiary,
      beneficiary_id: newCustomer.id,
    };
    setRows(newRows);
  };

  const handleVendorCreated = (newVendor) => {
    if (addModalRowIdx === null) return;
    const newRows = [...rows];
    const row = newRows[addModalRowIdx];
    const updatedBeneficiary = [...(row.beneficiary || []), { id: newVendor.id, name: newVendor.name }];
    newRows[addModalRowIdx] = {
      ...row,
      beneficiary: updatedBeneficiary,
      beneficiary_id: newVendor.id,
    };
    setRows(newRows);
  };

  const formatCurrency = (amount) => {
    return CisUI().getCurrencyFormatWithSymbol(currency, amount || 0);
  };

  // const amountInWords = (amount) => {
  //   if (!amount) return "";
  //   const ones = [
  //     "",
  //     "One",
  //     "Two",
  //     "Three",
  //     "Four",
  //     "Five",
  //     "Six",
  //     "Seven",
  //     "Eight",
  //     "Nine",
  //     "Ten",
  //     "Eleven",
  //     "Twelve",
  //     "Thirteen",
  //     "Fourteen",
  //     "Fifteen",
  //     "Sixteen",
  //     "Seventeen",
  //     "Eighteen",
  //     "Nineteen",
  //   ];
  //   const tens = ["", "", "Twenty", "Thirty", "Forty", "Fifty", "Sixty", "Seventy", "Eighty", "Ninety"];

  //   if (amount === 0) return "Zero Only";
  //   let num = Math.floor(amount);
  //   let result = "";
  //   if (num >= 1000) {
  //     result += ones[Math.floor(num / 1000)] + " Thousand ";
  //     num %= 1000;
  //   }
  //   if (num >= 100) {
  //     result += ones[Math.floor(num / 100)] + " Hundred ";
  //     num %= 100;
  //   }
  //   if (num >= 20) {
  //     result += tens[Math.floor(num / 10)] + " ";
  //     num %= 10;
  //   }
  //   if (num > 0) result += ones[num] + " ";
  //   return result.trim() + " Only";
  // };

  const templates = [
    {
      id: 1,
      name: "Monthly Office Rent",
      category: "Monthly Expense",
      shortcut: "RENT-MONTHLY",
      items: 1,
      amount: 4290,
      lastUsed: "20/08/2026",
      isFavorite: true,
    },
    {
      id: 2,
      name: "Office Supplies Payment",
      category: "Supplier Payment",
      shortcut: "SUPPLIES-PAY",
      items: 1,
      amount: 8250,
      lastUsed: "15/08/2026",
      isFavorite: false,
    },
    {
      id: 3,
      name: "Utility Bill Payment",
      category: "Utility",
      shortcut: "UTILITY-MONTHLY",
      items: 1,
      amount: 1250,
      lastUsed: "10/08/2026",
      isFavorite: false,
    },
    {
      id: 4,
      name: "Employee Advance",
      category: "Payroll",
      shortcut: "ADVANCE-EMP",
      items: 1,
      amount: 2000,
      lastUsed: "05/08/2026",
      isFavorite: false,
    },
  ];

  const filteredTemplates = templates.filter(
    (t) =>
      t.name.toLowerCase().includes(templateSearch.toLowerCase()) ||
      t.category.toLowerCase().includes(templateSearch.toLowerCase()) ||
      t.shortcut.toLowerCase().includes(templateSearch.toLowerCase()),
  );

  const templateMenuItems = [
    {
      key: "load",
      icon: <FileTextOutlined />,
      label: "Load From Template",
      onClick: () => {
        setLoadTemplateVisible(true);
      },
    },
    {
      key: "save",
      icon: <SaveOutlined />,
      label: "Save as Template",
      onClick: () => {
        setSaveTemplateVisible(true);
      },
    },
    { key: "manage", icon: <SettingOutlined />, label: "Manage Templates" },
  ];

  return (
    <div className="new-multiple-voucher">
      <style>{styles}</style>

      {/* Header */}
      <div className="nmv-header">
        <div className="nmv-header-left">
          <div className="nmv-header-icon">
            <BankOutlined />
          </div>
          <div>
            <h1 className="nmv-title">Voucher Entry</h1>
            <p className="nmv-subtitle">Create payment or receipt voucher</p>
          </div>
        </div>
        <div className="nmv-header-right">
          <Link to="/entries/manyvoucher">
            <Button className="nmv-switch-view" icon={<SwapOutlined />}>
              Switch to Simple View
            </Button>
          </Link>
          <Dropdown menu={{ items: templateMenuItems }} trigger={["click"]}>
            <Button className="nmv-templates-btn">
              <FileTextOutlined /> Templates <DownOutlined />
            </Button>
          </Dropdown>
          <Button className="nmv-settings-btn" icon={<SettingOutlined />} />
        </div>
      </div>

      <div className="nmv-body">
        <div className="nmv-main">
          <Form form={form} layout="vertical" onFinish={onFinish} ref={formRef}>
            {/* Section 1: Voucher Information */}
            <div className="nmv-section">
              <div className="nmv-section-header">
                <Badge count="1" style={{ backgroundColor: "#1890ff" }} />
                <span className="nmv-section-title">Voucher Information</span>
                {showTip && (
                  <div className="nmv-tip">
                    <InfoCircleOutlined style={{ color: "#1890ff", marginRight: 6 }} />
                    <span>Tip: Select the correct voucher type and payment method to ensure accurate accounting.</span>
                    <span className="nmv-tip-close" onClick={() => setShowTip(false)}>
                      &times;
                    </span>
                  </div>
                )}
              </div>

              <div className="nmv-form-row">
                <div className="nmv-form-group" style={{ flex: 1.2 }}>
                  <label className="nmv-label">
                    Voucher Type <span className="nmv-required">*</span>
                  </label>
                  <div className="nmv-voucher-type-group">
                    <button
                      type="button"
                      className={`nmv-voucher-type-btn ${voucherType === "Payment" ? "active" : ""}`}
                      onClick={() => setVoucherType("Payment")}
                    >
                      <CreditCardOutlined /> Payment
                    </button>
                    <button
                      type="button"
                      className={`nmv-voucher-type-btn ${voucherType === "Receipt" ? "active receipt" : ""}`}
                      onClick={() => setVoucherType("Receipt")}
                    >
                      <FileTextOutlined /> Receipt
                    </button>
                  </div>
                </div>
                <div className="nmv-form-group">
                  <label className="nmv-label">
                    Voucher Date <span className="nmv-required">*</span>
                  </label>
                  <Form.Item name="date" rules={[{ required: true, message: "Select a date" }]}>
                    <DatePicker
                      format={CisUI().dateFormat}
                      className="nmv-datepicker"
                      placeholder="Select date"
                      suffixIcon={<CalendarOutlined />}
                    />
                  </Form.Item>
                </div>
                {/* <div className="nmv-form-group">
                  <label className="nmv-label">
                    Voucher No. <span className="nmv-required">*</span>
                  </label>
                  <Form.Item name="reference_no" rules={[{ required: true }]}>
                    <Input
                      readOnly
                      className="nmv-input"
                    />
                  </Form.Item>
                </div> */}
                <div className="nmv-form-group">
                  <label className="nmv-label">
                    Payment Method <span className="nmv-required">*</span>
                  </label>
                  <Form.Item name="payment_method" initialValue={2} rules={[{ required: true }]}>
                    <Select className="nmv-select" onChange={handlePaymentMethodChange} suffixIcon={<BankOutlined />}>
                      {PaymentMethod.map((item, idx) => (
                        <Option key={idx} value={item.id}>
                          {item.name}
                        </Option>
                      ))}
                    </Select>
                  </Form.Item>
                </div>
              </div>

              <div className="nmv-form-row">
                {!isCash && (
                  <div className="nmv-form-group">
                    <label className="nmv-label">Bank</label>
                    <Form.Item name="bank_id" style={{ marginBottom: 0 }}>
                      <Select
                        className="nmv-select"
                        showSearch
                        optionFilterProp="children"
                        onChange={handleBankChange}
                        placeholder="Select a bank"
                      >
                        {BankName.map((item, idx) => (
                          <Option key={idx} value={item.bank_id}>
                            {item.name}
                          </Option>
                        ))}
                      </Select>
                    </Form.Item>
                  </div>
                )}

                <div className="nmv-form-group">
                  <label className="nmv-label">
                    Bank Account / Cash Account <span className="nmv-required">*</span>
                  </label>
                  <div className="nmv-bank-account-row">
                    <Form.Item name="bank_account_id" rules={[{ required: true }]} style={{ flex: 1, marginBottom: 0 }}>
                      <Select
                        className="nmv-select"
                        showSearch
                        optionFilterProp="children"
                        onChange={handleBankAccountChange}
                        placeholder="Select account"
                      >
                        {(isCash ? cashaccount : filteredBankAccount).map((item, idx) => (
                          <Option key={idx} value={item.id}>
                            {item.account_no || item.id} &bull; {item.account_name || item.name}
                          </Option>
                        ))}
                      </Select>
                    </Form.Item>
                    {/* <Button className="nmv-add-btn" icon={<PlusOutlined />} /> */}
                  </div>
                  {!isCash && (
                    <div className="nmv-balance">
                      Balance: <span className="nmv-balance-amount">{formatCurrency(bankAccountBalance)}</span>
                    </div>
                  )}
                </div>
                <div className="nmv-form-group">
                  <label className="nmv-label">
                    Currency <span className="nmv-required">*</span>
                  </label>
                  <Form.Item name="currency" initialValue={defaultCurrencyCode} rules={[{ required: true }]}>
                    <Select className="nmv-select" onChange={handleCurrencyChange}>
                      {AllCurrency.map((item, idx) => (
                        <Option key={idx} value={item.value}>
                          {item.name} ({item.value})
                        </Option>
                      ))}
                    </Select>
                  </Form.Item>
                </div>
                {currency !== "GHC" && (
                  <div className="nmv-form-group">
                    <label className="nmv-label">
                      Conversion Rate <span className="nmv-required">*</span>
                    </label>
                    <Form.Item name="conversion_rate" rules={[{ required: true, message: "Enter conversion rate" }]}>
                      <InputNumber
                        className="nmv-input"
                        placeholder="e.g. 12.50"
                        min={0}
                        precision={2}
                        onChange={handleConversionRateChange}
                      />
                    </Form.Item>
                  </div>
                )}
                <div className="nmv-form-group">
                  <label className="nmv-label">Cheque / Reference No.</label>
                  <Form.Item name="check_no">
                    <Input className="nmv-input" placeholder="Enter cheque or reference no." />
                  </Form.Item>
                </div>
              </div>

              <div className="nmv-form-row nmv-amount-row">
                <div className="nmv-form-group">
                  <label className="nmv-label">Remarks / Payee</label>
                  <Form.Item name="notes">
                    <TextArea className="nmv-textarea" placeholder="Enter remarks or payee name" rows={2} />
                  </Form.Item>
                </div>
                <div className="nmv-form-group nmv-amount-box">
                  <label className="nmv-label">
                    Payment Amount{" "}
                    <Tooltip title="Total payment amount">
                      <InfoCircleOutlined />
                    </Tooltip>
                  </label>
                  <div className="nmv-amount-display">
                    <span className="nmv-currency-symbol">$</span>
                    <span className="nmv-amount-value">
                      {totalAmount.toLocaleString("en-US", { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
                    </span>
                  </div>
                  {/* <div className="nmv-amount-words">({amountInWords(totalAmount)})</div> */}
                </div>
                <div className="nmv-form-group nmv-toggles">
                  <div className="nmv-toggle-item">
                    <label className="nmv-label">
                      Cheque Cleared?{" "}
                      <Tooltip title="Mark if cheque has been cleared">
                        <InfoCircleOutlined />
                      </Tooltip>
                    </label>
                    <Switch size="default" checked={checkStatus} onChange={setCheckStatus} />
                  </div>
                  <div className="nmv-toggle-item">
                    <label className="nmv-label">
                      Apply To All Lines?{" "}
                      <Tooltip title="Apply beneficiary to all line items">
                        <InfoCircleOutlined />
                      </Tooltip>
                    </label>
                    <Switch size="default" checked={applyAllBeneficiary} onChange={handleApplyAllBeneficiary} />
                  </div>
                  <div className="nmv-toggle-item">
                    <label className="nmv-label">
                      Cash In Transit?{" "}
                      <Tooltip title="Mark as cash in transit">
                        <InfoCircleOutlined />
                      </Tooltip>
                    </label>
                    <Switch size="default" checked={isCIT} onChange={setIsCIT} />
                  </div>
                </div>
              </div>
            </div>

            {/* Section 2: Voucher Items */}
            <div className="nmv-section">
              <div className="nmv-section-header">
                <Badge count="2" style={{ backgroundColor: "#1890ff" }} />
                <span className="nmv-section-title">Voucher Items</span>
                <div className="nmv-system-suggestion">
                  <InfoCircleOutlined style={{ color: "#faad14", marginRight: 4 }} />
                  <span style={{ color: "#faad14", fontWeight: 600 }}>System Suggestion:</span>
                  <span> You have {rows.length} lines. Total amount matches your bank account balance.</span>
                </div>
                <div className="nmv-items-actions">
                  <Button className="nmv-import-btn" icon={<FileExcelOutlined />}>
                    Import from Excel
                  </Button>
                  <Button
                    className="nmv-template-btn"
                    icon={<FileTextOutlined />}
                    onclick={() => setLoadTemplateVisible(true)}
                  >
                    Load From Template
                  </Button>
                </div>
              </div>

              <div className="nmv-items-table">
                <table>
                  <thead>
                    <tr>
                      <th className="nmv-th-num">#</th>
                      <th className="nmv-th-account">
                        Account / GL Head <span className="nmv-required">*</span>
                      </th>
                      <th className="nmv-th-beneficiary">Beneficiary Source</th>
                      <th className="nmv-th-beneficiary">Beneficiary</th>
                      <th className="nmv-th-desc">Item Description</th>
                      <th className="nmv-th-amount">
                        {voucherType === "Payment" ? "Payment Amount" : "Receipt Amount"}{" "}
                        <span className="nmv-required">*</span>
                      </th>
                      <th className="nmv-th-action">Action</th>
                    </tr>
                  </thead>
                  <tbody>
                    {rows.map((row, idx) => (
                      <tr key={idx}>
                        <td className="nmv-td-num">{idx + 1}</td>
                        <td>
                          <div className="nmv-cell-selects">
                            <Select
                              className="nmv-table-select"
                              showSearch
                              placeholder="Select account"
                              optionFilterProp="children"
                              value={row.account_id}
                              onChange={(v) => handleRowChange(idx, "account_id", v)}
                            >
                              {mainAccount.map((item, i) => (
                                <Option key={i} value={item.id}>
                                  {item.account_number} &bull; {item.name}
                                </Option>
                              ))}
                            </Select>
                            {/* <Button className="nmv-cell-add-btn" icon={<PlusOutlined />} size="small" /> */}
                          </div>
                        </td>
                        <td>
                          <Select
                            className="nmv-table-select"
                            showSearch
                            placeholder="Select source"
                            optionFilterProp="children"
                            value={row.beneficiary_source}
                            onChange={(v) => handleRowChange(idx, "beneficiary_source", v)}
                          >
                            {Benificiary.map((item, i) => (
                              <Option key={i} value={item.id}>
                                {item.name}
                              </Option>
                            ))}
                          </Select>
                        </td>
                        <td>
                          <div className="nmv-cell-selects">
                            <Select
                              className="nmv-table-select"
                              showSearch
                              placeholder="Select beneficiary"
                              optionFilterProp="children"
                              value={row.beneficiary_id}
                              onChange={(v) => handleRowChange(idx, "beneficiary_id", v)}
                            >
                              {(row.beneficiary || []).map((item, i) => (
                                <Option key={i} value={item.id}>
                                  {item.name}
                                </Option>
                              ))}
                            </Select>
                            {[2, 3, 17].includes(row.beneficiary_source) && (
                              <Button
                                className="nmv-cell-add-btn"
                                icon={<PlusOutlined />}
                                size="small"
                                onClick={() => {
                                  setAddModalRowIdx(idx);
                                  if (row.beneficiary_source === 3) {
                                    setVendorModalVisible(true);
                                  } else {
                                    setCustomerModalVisible(true);
                                  }
                                }}
                              />
                            )}
                          </div>
                        </td>
                        <td>
                          <Input
                            className="nmv-table-input"
                            placeholder="Enter description"
                            value={row.description}
                            onChange={(e) => handleRowChange(idx, "description", e.target.value)}
                          />
                        </td>
                        <td>
                          <InputNumber
                            className="nmv-table-amount"
                            placeholder="0.00"
                            value={row.amount}
                            onChange={(v) => handleRowChange(idx, "amount", v)}
                            min={0}
                            precision={2}
                          />
                          {currency !== "GHC" && (
                            <div style={{ fontSize: 11, color: "#1890ff", marginTop: 2 }}>
                              GHC {CisUI().getCurrencyFormated1(row.amount_in_ghc || 0)}
                            </div>
                          )}
                        </td>
                        <td className="nmv-td-actions">
                          <Tooltip title="Duplicate">
                            <Button
                              type="text"
                              size="small"
                              icon={<CopyOutlined />}
                              className="nmv-action-btn"
                              style={{ marginBottom: 0 }}
                              onClick={() => handleDuplicateRow(idx)}
                            />
                          </Tooltip>
                          <Tooltip title="Delete">
                            <Button
                              type="text"
                              size="small"
                              icon={<DeleteOutlined />}
                              className="nmv-action-btn delete"
                              onClick={() => handleRemoveRow(idx)}
                            />
                          </Tooltip>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>

              <div className="nmv-items-footer">
                <Button className="nmv-add-line-btn" icon={<PlusOutlined />} onClick={handleAddRow}>
                  Add New Line
                </Button>
                <div className="nmv-total">
                  <span className="nmv-total-label">Total Amount</span>
                  <div style={{ textAlign: "right" }}>
                    <span className="nmv-total-value">{formatCurrency(totalAmount)}</span>
                    {currency !== "GHC" && (
                      <div style={{ fontSize: 12, color: "#1890ff", marginTop: 2 }}>
                        Total in GHC:{" "}
                        {CisUI().getCurrencyFormated1(
                          rows.reduce((sum, r) => sum + (parseFloat(r.amount_in_ghc) || 0), 0),
                        )}
                      </div>
                    )}
                  </div>
                </div>
              </div>
            </div>

            {/* Section 3: Attachments */}
            <div className="nmv-section">
              <div className="nmv-section-header">
                <Badge count="3" style={{ backgroundColor: "#1890ff" }} />
                <span className="nmv-section-title">Attachments (Optional)</span>
              </div>
              <Upload.Dragger
                multiple
                fileList={attachments}
                beforeUpload={() => false}
                onChange={({ fileList }) => setAttachments(fileList)}
                className="nmv-upload-area"
              >
                <p className="nmv-upload-icon">
                  <CloudUploadOutlined />
                </p>
                <p className="nmv-upload-text">
                  Drag & drop files here or click to <span className="nmv-upload-browse">browse</span>
                </p>
                <p className="nmv-upload-hint">Supports: PDF, JPG, PNG (Max 5MB)</p>
              </Upload.Dragger>
            </div>

            {/* Footer */}
            <div className="nmv-footer">
              <Button className="nmv-clear-btn" icon={<ReloadOutlined />}>
                Clear
              </Button>
              <div className="nmv-footer-right">
                <Button className="nmv-draft-btn" onClick={() => message.info("Saved as draft")}>
                  Save as Draft
                </Button>
                 <Button className="nmv-post-btn" type="primary" htmlType="submit" loading={loading}>
                    Save
                  </Button>
              </div>
            </div>
          </Form>
        </div>

        {/* System Assistant Panel - Sidebar (wide screens) */}
        {isWideScreen && (
          <SystemAssistantSidebar showAssistant={showAssistant} onClose={() => setShowAssistant(false)} />
        )}
      </div>

      {/* Re-show assistant button when hidden */}
      {!showAssistant && (
        <button
          className="nmv-assistant-reopen"
          onClick={() => {
            if (isWideScreen) {
              setShowAssistant(true);
            } else {
              setDrawerVisible(true);
            }
          }}
          title="Show System Assistant"
        >
          ✦
        </button>
      )}

      {/* System Assistant - Drawer (narrow screens) */}
      {!isWideScreen && (
        <Drawer
          placement="right"
          onClose={() => {
            setDrawerVisible(false);
            setShowAssistant(false);
          }}
          open={drawerVisible}
          width={340}
          className="nmv-assistant-drawer-wrapper"
          styles={{ body: { padding: 0 } }}
        >
          <SystemAssistantDrawerContent
            onClose={() => {
              setDrawerVisible(false);
              setShowAssistant(false);
            }}
          />
        </Drawer>
      )}

      {/* Load From Template Modal */}
      <Modal
        title="Load From Template"
        open={loadTemplateVisible}
        onCancel={() => setLoadTemplateVisible(false)}
        footer={
          <div className="nmv-modal-footer">
            <Button onClick={() => setLoadTemplateVisible(false)}>Cancel</Button>
            <Button type="primary" disabled={!selectedTemplate}>
              Load Template
            </Button>
          </div>
        }
        width={560}
        className="nmv-template-modal"
      >
        <div className="nmv-template-search">
          <Input
            prefix={<SearchOutlined />}
            placeholder="Search templates by name, category or shortcut..."
            value={templateSearch}
            onChange={(e) => setTemplateSearch(e.target.value)}
            suffix={<FilterOutlined style={{ color: "#bfbfbf", cursor: "pointer" }} />}
          />
        </div>
        <div className="nmv-template-list">
          {filteredTemplates.map((t) => (
            <div
              key={t.id}
              className={`nmv-template-item ${selectedTemplate === t.id ? "selected" : ""}`}
              onClick={() => setSelectedTemplate(t.id)}
            >
              <input
                type="radio"
                checked={selectedTemplate === t.id}
                onChange={() => setSelectedTemplate(t.id)}
                className="nmv-template-radio"
              />
              <div className="nmv-template-info">
                <div className="nmv-template-name">
                  {t.name}
                  {t.isFavorite && <StarFilled style={{ color: "#faad14", marginLeft: 4 }} />}
                </div>
                <div className="nmv-template-meta">
                  {t.category} &bull; {t.shortcut}
                </div>
                <div className="nmv-template-details">
                  {t.items} item &bull; $ {t.amount.toLocaleString("en-US", { minimumFractionDigits: 2 })}
                </div>
              </div>
              <div className="nmv-template-last-used">
                Last used
                <br />
                {t.lastUsed}
              </div>
            </div>
          ))}
        </div>
        <div className="nmv-template-modal-footer">
          <Button type="link" icon={<SettingOutlined />}>
            Manage Templates
          </Button>
        </div>
      </Modal>

      {/* Save as Template Modal */}
      <Modal
        title="Save Voucher as Template"
        open={saveTemplateVisible}
        onCancel={() => setSaveTemplateVisible(false)}
        footer={
          <div className="nmv-modal-footer">
            <Button onClick={() => setSaveTemplateVisible(false)}>Cancel</Button>
            <Button type="primary">Save Template</Button>
          </div>
        }
        width={520}
        className="nmv-save-template-modal"
      >
        <div className="nmv-template-notice">
          <InfoCircleOutlined style={{ color: "#1890ff", marginRight: 8 }} />
          Save the current voucher setup as a template for recurring use. Voucher date and voucher number will not be
          saved.
        </div>
        <Form form={saveTemplateForm} layout="vertical">
          <div className="nmv-template-form-row">
            <Form.Item label="Template Name" name="templateName" rules={[{ required: true }]} style={{ flex: 1 }}>
              <Input placeholder="e.g. Monthly Office Rent" />
            </Form.Item>
            <Form.Item label="Category" name="category" rules={[{ required: true }]} style={{ flex: 1 }}>
              <Select placeholder="Select category">
                <Option value="Monthly Expense">Monthly Expense</Option>
                <Option value="Supplier Payment">Supplier Payment</Option>
                <Option value="Utility">Utility</Option>
                <Option value="Payroll">Payroll</Option>
              </Select>
            </Form.Item>
            <Form.Item label="Shortcut / Reference" name="shortcut" style={{ flex: 1 }}>
              <Input placeholder="e.g. RENT-MONTHLY" />
            </Form.Item>
          </div>
          <Form.Item label="Description" name="description">
            <TextArea rows={2} placeholder="Recurring monthly office rent payment" />
          </Form.Item>
          <div className="nmv-template-checkboxes">
            <Checkbox defaultChecked>Save line amounts</Checkbox>
            <Checkbox defaultChecked>Save beneficiaries</Checkbox>
            <Checkbox defaultChecked>Save bank / cash account</Checkbox>
          </div>
          <div className="nmv-template-checkboxes">
            <Checkbox>Save reference / cheque no.</Checkbox>
            <Checkbox>Include remarks</Checkbox>
          </div>
          <div className="nmv-template-favorite">
            <Checkbox>
              <StarOutlined style={{ color: "#faad14" }} /> Mark as favorite
            </Checkbox>
          </div>
        </Form>
      </Modal>

      {/* Excel Import Modal */}
      <Modal
        title="Excel Import"
        open={false}
        footer={[
          <Button key="done" type="primary">
            Done
          </Button>,
        ]}
      >
        <p>Import vouchers from Excel file.</p>
      </Modal>

      <CreateCustomerModal
        visible={customerModalVisible}
        onClose={() => {
          setCustomerModalVisible(false);
          setAddModalRowIdx(null);
        }}
        onSuccess={handleCustomerCreated}
      />
      <CreateVendorModal
        visible={vendorModalVisible}
        onClose={() => {
          setVendorModalVisible(false);
          setAddModalRowIdx(null);
        }}
        onSuccess={handleVendorCreated}
      />
    </div>
  );
};

const styles = `
  .new-multiple-voucher {
    font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;
    background: #f5f7fa;
    min-height: 100vh;
    padding: 0;
  }

  /* Header */
  .nmv-header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 16px 24px;
    background: #fff;
    border-bottom: 1px solid #e8e8e8;
  }
  .nmv-header-left {
    display: flex;
    align-items: center;
    gap: 12px;
  }
  .nmv-header-icon {
    width: 44px;
    height: 44px;
    background: linear-gradient(135deg, #e6f7ff, #bae7ff);
    border-radius: 10px;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 20px;
    color: #1890ff;
  }
  .nmv-title {
    font-size: 20px;
    font-weight: 700;
    color: #1a1a2e;
    margin: 0;
    line-height: 1.2;
  }
  .nmv-subtitle {
    font-size: 13px;
    color: #8c8c8c;
    margin: 0;
  }
  .nmv-header-right {
    display: flex;
    align-items: center;
    gap: 8px;
  }
  .nmv-switch-view {
    border: 1px solid #d9d9d9;
    color: #1890ff;
    font-weight: 500;
    border-radius: 8px;
  }
  .nmv-switch-view:hover {
    border-color: #1890ff;
    color: #1890ff;
  }
  .nmv-templates-btn {
    border: 1px solid #d9d9d9;
    font-weight: 500;
    border-radius: 8px;
    display: flex;
    align-items: center;
    gap: 4px;
  }
  .nmv-settings-btn {
    border: 1px solid #d9d9d9;
    border-radius: 8px;
    width: 36px;
    height: 36px;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .nmv-assistant-reopen {
    position: fixed;
    bottom: 24px;
    right: 24px;
    width: 44px;
    height: 44px;
    border-radius: 50%;
    border: none;
    background: #1890ff;
    color: #fff;
    font-size: 18px;
    cursor: pointer;
    box-shadow: 0 4px 12px rgba(24, 144, 255, 0.4);
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 100;
    transition: all 0.2s;
  }
  .nmv-assistant-reopen:hover {
    background: #40a9ff;
    transform: scale(1.1);
  }

  /* Body Layout */
  .nmv-body {
    display: flex;
    gap: 16px;
    padding: 16px 24px;
    max-width: 1600px;
    margin: 0 auto;
  }
  .nmv-main {
    flex: 1;
    min-width: 0;
  }

  /* Section */
  .nmv-section {
    background: #fff;
    border-radius: 12px;
    padding: 20px 24px;
    margin-bottom: 16px;
    border: 1px solid #e8e8e8;
  }
  .nmv-section-header {
    display: flex;
    align-items: center;
    gap: 10px;
    margin-bottom: 16px;
    flex-wrap: wrap;
  }
  .nmv-section-title {
    font-size: 16px;
    font-weight: 700;
    color: #1a1a2e;
  }
  .nmv-tip {
    display: flex;
    align-items: center;
    background: #e6f7ff;
    border: 1px solid #91d5ff;
    border-radius: 8px;
    padding: 6px 12px;
    font-size: 12.5px;
    color: #1890ff;
    margin-left: auto;
  }
  .nmv-tip-close {
    margin-left: 8px;
    cursor: pointer;
    font-size: 16px;
    color: #8c8c8c;
  }
  .nmv-tip-close:hover {
    color: #ff4d4f;
  }

  /* Form Row */
  .nmv-form-row {
    display: flex;
    gap: 16px;
    margin-bottom: 8px;
    align-items: flex-start;
  }
  .nmv-form-group {
    display: flex;
    flex-direction: column;
    flex: 1;
    min-width: 0;
  }
  .nmv-label {
    font-size: 13px;
    font-weight: 600;
    color: #333;
    margin-bottom: 6px;
    display: flex;
    align-items: center;
    gap: 4px;
  }
  .nmv-required {
    color: #ff4d4f;
  }

  /* Voucher Type Buttons */
  .nmv-voucher-type-group {
    display: flex;
    gap: 0;
  }
  .nmv-voucher-type-btn {
    padding: 8px 24px;
    border: 1px solid #d9d9d9;
    background: #fff;
    cursor: pointer;
    font-size: 13px;
    font-weight: 500;
    display: flex;
    align-items: center;
    gap: 6px;
    transition: all 0.2s;
    color: #666;
  }
  .nmv-voucher-type-btn:first-child {
    border-radius: 8px 0 0 8px;
  }
  .nmv-voucher-type-btn:last-child {
    border-radius: 0 8px 8px 0;
    border-left: none;
  }
  .nmv-voucher-type-btn.active {
    background: #e6f7ff;
    border-color: #1890ff;
    color: #1890ff;
    font-weight: 600;
  }
  .nmv-voucher-type-btn.active.receipt {
    background: #f6ffed;
    border-color: #52c41a;
    color: #52c41a;
  }
  .nmv-voucher-type-btn:hover:not(.active) {
    border-color: #1890ff;
    color: #1890ff;
  }

  /* Inputs, Selects */
  .nmv-datepicker,
  .nmv-select,
  .nmv-input {
    width: 100%;
    height: 38px;
    border-radius: 8px;
  }
  .nmv-textarea {
    border-radius: 8px;
  }
  .nmv-input.readonly {
    background: #fafafa;
  }

  /* Bank Account Row */
  .nmv-bank-account-row {
    display: flex;
    gap: 6px;
    align-items: flex-start;
  }
  .nmv-add-btn {
    width: 38px;
    height: 38px;
    border-radius: 8px;
    display: flex;
    align-items: center;
    justify-content: center;
    border: 1px solid #d9d9d9;
    color: #1890ff;
    flex-shrink: 0;
  }
  .nmv-add-btn:hover {
    border-color: #1890ff;
    background: #e6f7ff;
  }
  .nmv-balance {
    font-size: 12px;
    color: #ff4d4f;
    margin-top: 4px;
    padding-left: 2px;
  }
  .nmv-balance-amount {
    font-weight: 600;
  }

  /* Amount Display */
  .nmv-amount-row {
    align-items: flex-start;
  }
  .nmv-amount-box {
    background: #fafafa;
    border: 1px solid #e8e8e8;
    border-radius: 10px;
    padding: 12px 16px;
    width: 220px;
    flex: none;
  }
  .nmv-amount-display {
    display: flex;
    align-items: baseline;
    gap: 6px;
  }
  .nmv-currency-symbol {
    font-size: 18px;
    color: #1890ff;
    font-weight: 600;
  }
  .nmv-amount-value {
    font-size: 24px;
    font-weight: 700;
    color: #1890ff;
  }
  .nmv-amount-words {
    font-size: 11px;
    color: #8c8c8c;
    margin-top: 2px;
    font-style: italic;
  }

  /* Toggles */
  .nmv-toggles {
    display: flex;
    gap: 20px;
    flex: 1;
    flex-direction: row;
  }
  .nmv-toggle-item {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    gap: 4px;
  }
  .nmv-toggle-item .nmv-label {
    font-size: 12px;
    white-space: nowrap;
  }

  /* Items Section */
  .nmv-items-actions {
    display: flex;
    gap: 8px;
    margin-left: auto;
  }
  .nmv-import-btn,
  .nmv-template-btn {
    border: 1px solid #d9d9d9;
    border-radius: 8px;
    font-size: 12.5px;
    display: flex;
    align-items: center;
    gap: 4px;
  }
  .nmv-import-btn:hover {
    border-color: #1890ff;
    color: #1890ff;
  }
  .nmv-system-suggestion {
    font-size: 12px;
    color: #666;
    margin-left: 12px;
  }

  /* Items Table */
  .nmv-items-table {
    overflow-x: auto;
  }
  .nmv-items-table table {
    width: 100%;
    border-collapse: collapse;
    border: 1px solid #e8e8e8;
    border-radius: 8px;
    overflow: hidden;
  }
  .nmv-items-table th {
    background: #fafafa;
    padding: 10px 12px;
    font-size: 12.5px;
    font-weight: 600;
    color: #333;
    text-align: left;
    border-bottom: 1px solid #e8e8e8;
    white-space: nowrap;
  }
  .nmv-items-table td {
    padding: 10px 12px;
    border-bottom: 1px solid #f0f0f0;
    vertical-align: top;
  }
  .nmv-items-table tr:last-child td {
    border-bottom: none;
  }
  .nmv-th-num { width: 40px; text-align: center; }
  .nmv-th-account { min-width: 200px; }
  .nmv-th-beneficiary { min-width: 160px; }
  .nmv-th-desc { min-width: 180px; }
  .nmv-th-amount { min-width: 130px; }
  .nmv-th-action { width: 80px; text-align: center; }
  .nmv-td-num { text-align: center; color: #8c8c8c; font-weight: 500; }
  .nmv-cell-selects {
    display: flex;
    gap: 4px;
    align-items: flex-start;
  }
  .nmv-cell-add-btn {
    border: 1px solid #d9d9d9;
    color: #1890ff;
    border-radius: 6px;
    flex-shrink: 0;
    margin-top: 2px;
  }
  .nmv-cell-add-btn:hover {
    border-color: #1890ff;
    background: #e6f7ff;
  }
  .nmv-table-select {
    width: 100%;
    min-width: 150px;
  }
  .nmv-table-input {
    width: 100%;
    min-width: 150px;
  }
  .nmv-table-amount {
    width: 120px;
  }
  .nmv-td-actions {
    text-align: center;
    white-space: nowrap;
  }
  .nmv-action-btn {
    color: #1890ff;
    border: none;
    padding: 4px;
  }
  .nmv-action-btn:hover {
    color: #40a9ff;
    background: #e6f7ff;
  }
  .nmv-action-btn.delete {
    color: #ff4d4f;
  }
  .nmv-action-btn.delete:hover {
    color: #ff7875;
    background: #fff1f0;
  }

  /* Items Footer */
  .nmv-items-footer {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-top: 12px;
  }
  .nmv-add-line-btn {
    border: 1px dashed #1890ff;
    color: #1890ff;
    border-radius: 8px;
    display: flex;
    align-items: center;
    gap: 4px;
    background: #e6f7ff;
  }
  .nmv-add-line-btn:hover {
    background: #bae7ff;
  }
  .nmv-total {
    display: flex;
    align-items: center;
    gap: 16px;
  }
  .nmv-total-label {
    font-size: 14px;
    font-weight: 600;
    color: #333;
  }
  .nmv-total-value {
    font-size: 18px;
    font-weight: 700;
    color: #1890ff;
  }

  /* Upload Area */
  .nmv-upload-area {
    border: 2px dashed #d9d9d9 !important;
    border-radius: 10px !important;
    background: #fafafa !important;
    padding: 20px !important;
    text-align: center;
  }
  .nmv-upload-area:hover {
    border-color: #1890ff !important;
  }
  .nmv-upload-icon {
    font-size: 36px;
    color: #bfbfbf;
    margin-bottom: 8px;
  }
  .nmv-upload-text {
    font-size: 13px;
    color: #666;
  }
  .nmv-upload-browse {
    color: #1890ff;
    cursor: pointer;
    font-weight: 500;
  }
  .nmv-upload-hint {
    font-size: 12px;
    color: #bfbfbf;
    margin-top: 4px;
  }

  /* Footer */
  .nmv-footer {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 16px 0;
  }
  .nmv-clear-btn {
    border: 1px solid #d9d9d9;
    border-radius: 8px;
    display: flex;
    align-items: center;
    gap: 4px;
    color: #666;
  }
  .nmv-footer-right {
    display: flex;
    gap: 8px;
  }
  .nmv-draft-btn {
    border: 1px solid #d9d9d9;
    border-radius: 8px;
    color: #333;
    font-weight: 500;
  }
  .nmv-post-btn {
    border-radius: 8px;
    font-weight: 600;
    background: #1890ff;
    border-color: #1890ff;
    display: flex;
    align-items: center;
    gap: 4px;
  }
  .nmv-post-btn:hover {
    background: #40a9ff;
    border-color: #40a9ff;
  }

  /* System Assistant */
  .nmv-assistant {
    width: 300px;
    flex-shrink: 0;
    background: #fff;
    border-radius: 12px;
    border: 1px solid #e8e8e8;
    height: fit-content;
    position: sticky;
    top: 16px;
    overflow: hidden;
  }
  .nmv-assistant-header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 16px 20px;
  }
  .nmv-assistant-title {
    font-size: 15px;
    font-weight: 700;
    color: #1a1a2e;
    display: flex;
    align-items: center;
    gap: 8px;
  }
  .nmv-assistant-icon {
    color: #1890ff;
    font-size: 16px;
  }
  .nmv-assistant-collapse {
    background: none;
    border: none;
    cursor: pointer;
    padding: 4px;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 4px;
    transition: background 0.2s;
  }
  .nmv-assistant-collapse:hover {
    background: #f5f5f5;
  }
  .nmv-assistant-body {
    padding: 0 20px 20px;
  }
  .nmv-assistant-intro {
    font-size: 13px;
    color: #666;
    margin: 0 0 20px;
    line-height: 1.6;
  }
  .nmv-assistant-section-title {
    font-size: 13.5px;
    font-weight: 700;
    color: #1a1a2e;
    margin-bottom: 14px;
  }
  .nmv-assistant-divider {
    height: 1px;
    background: #f0f0f0;
    margin: 16px 0;
  }

  /* Suggestion Cards */
  .nmv-suggestion-card {
    display: flex;
    align-items: flex-start;
    gap: 10px;
    padding: 12px 0;
  }
  .nmv-suggestion-card + .nmv-suggestion-card {
    border-top: 1px solid #f5f5f5;
  }
  .nmv-suggestion-icon {
    flex-shrink: 0;
    margin-top: 1px;
  }
  .nmv-suggestion-content {
    flex: 1;
    min-width: 0;
  }
  .nmv-suggestion-title {
    font-size: 13px;
    font-weight: 600;
    color: #1a1a2e;
    margin-bottom: 3px;
  }
  .nmv-suggestion-desc {
    font-size: 12px;
    color: #8c8c8c;
    line-height: 1.5;
  }

  /* Outline Buttons */
  .nmv-outline-btn {
    margin-top: 8px;
    padding: 4px 12px;
    border: 1px solid #d9d9d9;
    border-radius: 6px;
    background: #fff;
    font-size: 12px;
    cursor: pointer;
    transition: all 0.2s;
    font-weight: 500;
  }
  .nmv-outline-btn.blue {
    border-color: #1890ff;
    color: #1890ff;
  }
  .nmv-outline-btn.blue:hover {
    background: #e6f7ff;
    border-color: #40a9ff;
  }

  /* Help Links */
  .nmv-help-links {
    margin-bottom: 14px;
  }
  .nmv-help-link {
    display: flex;
    align-items: center;
    gap: 8px;
    font-size: 12.5px;
    color: #1890ff;
    padding: 7px 0;
    cursor: pointer;
    line-height: 1.4;
  }
  .nmv-help-link:hover {
    text-decoration: underline;
  }
  .nmv-help-icon {
    flex-shrink: 0;
    display: flex;
    align-items: center;
  }
  .nmv-help-center-btn {
    width: 100%;
    padding: 8px 16px;
    border: 1px solid #d9d9d9;
    border-radius: 8px;
    background: #fff;
    font-size: 13px;
    font-weight: 500;
    color: #333;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 6px;
    transition: all 0.2s;
  }
  .nmv-help-center-btn:hover {
    border-color: #1890ff;
    color: #1890ff;
  }

  /* Template Modal */
  .nmv-template-search {
    margin-bottom: 12px;
  }
  .nmv-template-list {
    max-height: 400px;
    overflow-y: auto;
  }
  .nmv-template-item {
    display: flex;
    align-items: center;
    gap: 12px;
    padding: 12px;
    border: 1px solid #e8e8e8;
    border-radius: 8px;
    margin-bottom: 8px;
    cursor: pointer;
    transition: all 0.2s;
  }
  .nmv-template-item:hover {
    border-color: #1890ff;
    background: #f0f7ff;
  }
  .nmv-template-item.selected {
    border-color: #1890ff;
    background: #e6f7ff;
  }
  .nmv-template-radio {
    margin-top: 2px;
    accent-color: #1890ff;
  }
  .nmv-template-info {
    flex: 1;
  }
  .nmv-template-name {
    font-size: 13px;
    font-weight: 600;
    color: #333;
    display: flex;
    align-items: center;
  }
  .nmv-template-meta {
    font-size: 11.5px;
    color: #8c8c8c;
    margin-top: 2px;
  }
  .nmv-template-details {
    font-size: 11.5px;
    color: #1890ff;
    font-weight: 500;
    margin-top: 2px;
  }
  .nmv-template-last-used {
    font-size: 11px;
    color: #bfbfbf;
    text-align: right;
    white-space: nowrap;
  }
  .nmv-template-modal-footer {
    padding-top: 12px;
    border-top: 1px solid #f0f0f0;
    margin-top: 8px;
  }
  .nmv-modal-footer {
    display: flex;
    justify-content: flex-end;
    gap: 8px;
  }

  /* Save Template Modal */
  .nmv-template-notice {
    background: #e6f7ff;
    border: 1px solid #91d5ff;
    border-radius: 8px;
    padding: 10px 14px;
    font-size: 12px;
    color: #1890ff;
    margin-bottom: 16px;
    display: flex;
    align-items: flex-start;
  }
  .nmv-template-form-row {
    display: flex;
    gap: 12px;
  }
  .nmv-template-checkboxes {
    display: flex;
    gap: 16px;
    margin-bottom: 8px;
  }
  .nmv-template-favorite {
    margin-top: 8px;
  }
  .nmv-template-favorite .ant-checkbox-wrapper {
    color: #faad14;
  }

  /* Ant Design overrides */
  .new-multiple-voucher .ant-form-item {
    margin-bottom: 0;
  }
  .new-multiple-voucher .ant-select-selector {
    border-radius: 8px !important;
    height: 38px !important;
  }
  .new-multiple-voucher .ant-input,
  .new-multiple-voucher .ant-input-number {
    border-radius: 8px;
  }
  .new-multiple-voucher .ant-picker {
    border-radius: 8px;
  }
  .new-multiple-voucher .ant-input-textarea textarea {
    border-radius: 8px;
  }
  .new-multiple-voucher .ant-input-number-input {
    text-align: right;
  }

  /* Responsive */
  /* Drawer override */
  .nmv-assistant-drawer-wrapper .ant-drawer-body {
    padding: 0;
  }
  .nmv-assistant-drawer .nmv-assistant {
    border: none;
    border-radius: 0;
    box-shadow: none;
  }

  @media (max-width: 1200px) {
    .nmv-body {
      flex-direction: column;
    }
    .nmv-assistant {
      width: 100%;
      position: static;
    }
    .nmv-form-row {
      flex-wrap: wrap;
    }
  }
`;

export default NewMultipleVoucher;
